var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWelcome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 368,
  height: 188
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "welcome_svg__b",
  x1: "9.995%",
  x2: "100%",
  y1: "9.877%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#9AEBC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#66BB8E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "welcome_svg__d",
  x1: "54.377%",
  x2: "54.377%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#489EB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#98E1F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "welcome_svg__e",
  x1: "9.995%",
  x2: "100%",
  y1: "9.877%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#EFC1A5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CD7A47"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "welcome_svg__f",
  x1: "9.995%",
  x2: "87.495%",
  y1: "9.877%",
  y2: "87.654%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "-1.31%",
  stopColor: "#FFEFB2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFEFB1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFD266"
})), /*#__PURE__*/React.createElement("path", {
  id: "welcome_svg__a",
  d: "M0 0h211.116v105.629H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-852-544H748V794H-852z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEF0F1",
  d: "M299.676 84.78c0-46.576-42.702-84.78-92.881-84.78-25.451 0-48.5 10.3-65.33 26.957-.596.55-.658.608-.719.669-9.444 9.507-123.718 124.479-134.63 135.47C-5.273 174.572-.279 188 17.129 188h298.423C346.467 188 368 164.333 368 135.155c0-29.186-23.48-52.853-52.448-52.853-5.537 0-10.868.875-15.876 2.478"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(100.716 63.959)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "welcome_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#welcome_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#welcome_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#welcome_svg__b)",
  d: "M57.915 28.553h73.98v96.561h-73.98z",
  mask: "url(#welcome_svg__c)"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#welcome_svg__c)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(22 22.98 294.74)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#welcome_svg__d)",
  d: "M0 0h97.945v72.68H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7DCBE0",
  d: "M0 36.34h97.945v36.34H0z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 48.973,
  cy: 35.821,
  fill: "#FAFAFA",
  rx: 19.797,
  ry: 19.208
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9DDCEC",
  d: "M68.763 37.378h-39.58c.283 10.369 9.035 18.69 19.79 18.69s19.507-8.321 19.79-18.69"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#welcome_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#welcome_svg__e)",
  d: "M0 0h73.98v96.561H0z",
  transform: "rotate(-22 78.8 3.82)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#welcome_svg__f)",
  d: "M36.99 74.757c14.674 0 26.57-11.621 26.57-25.957S51.664 22.842 36.99 22.842 10.42 34.464 10.42 48.8s11.896 25.957 26.57 25.957",
  transform: "rotate(-22 78.8 3.82)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6AB43",
  d: "M68.93 61.9c1.94 4.803-1.012 10.524-6.595 12.78-5.582 2.255-11.68.191-13.62-4.611"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#B09759",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.55 48.903a4.3 4.3 0 0 1-2.365 5.6 4.3 4.3 0 0 1-5.592-2.385M49.4 55.538a4.3 4.3 0 0 1-2.366 5.6 4.3 4.3 0 0 1-5.592-2.385"
})))), /*#__PURE__*/React.createElement("path", {
  fill: "#EEF0F1",
  d: "M315.069 177.178c-16.448-21.686-42.479-35.693-71.783-35.693-26.36 0-50.073 11.333-66.543 29.394-8.794-10.498-21.99-17.176-36.749-17.176-17.53 0-32.856 9.42-41.215 23.475"
}))));
export default SvgWelcome;